export const siteInfo = {
  name: "汗汗漫画",
  slogan: "悬疑推理追更专区",
  description:
    "汗汗漫画悬疑推理追更专区，汇集悬疑、推理、烧脑、反转、案件、解密等类型漫画，剧情反转不断，满足你的推理阅读需求，在线看追更入口。",
  url: "https://wpnbp71.cn",
  email: "contact@hanhan-comic.example.com",
  year: "2026",
};